module.exports = __webpack_public_path__ + "static/img/temp-3.466cab65.jpg";